module.exports = __webpack_public_path__ + "fonts/b17c123abad47e352f01436669e3a9c6.txt";